module.exports = __webpack_public_path__ + "assets/MARK_-_Social.fb0ec799.svg";